module.exports = __webpack_public_path__ + "img/level3.da209e78.png";